export interface AppConfig {
  BASE_URL: string;
  BASE_URL_ANALYTICS?: string;
  BASE_URL_MANAGER?: string;
  NODE_ENV?: "development" | "production" | "test";
  APP_NAME?: string;
  VERSION?: string;
  FAST_REFRESH?: boolean;
  DISABLE_ESLINT_PLUGIN?: boolean;
  PORT?: number;
}

// Extend global window
declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

let cached: AppConfig | null = null;

export const getConfig = (): AppConfig => {
  if (cached){ 
    return cached;
  }

  if (typeof window === "undefined" || !window.__APP_CONFIG__) {
    throw new Error(
      "Runtime config not loaded. Make sure index.html fetches public/config.json before app start."
    );
  }

  cached = window.__APP_CONFIG__;
  return cached;
};

// Helper functions
export const getBaseUrl = (): string => getConfig().BASE_URL ?? "";
export const getAnalyticsUrl = (): string => getConfig().BASE_URL_ANALYTICS ?? "";
export const getManagerUrl = (): string => getConfig().BASE_URL_MANAGER ?? "";
export const isProduction = (): boolean => getConfig().NODE_ENV === "production";
export const isDevelopment = (): boolean => getConfig().NODE_ENV === "development";
export const getAppName = (): string => getConfig().APP_NAME ?? "Sygno Platform";
export const getAppVersion = (): string => getConfig().VERSION ?? "v3-3.02.00";
export const getPort = (): number => getConfig().PORT ?? 3000;